import React from 'react';
import { ITableDataSource } from 'models/table';
import { colors } from 'theme/colors';
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';
import Button from 'components/atoms/Button';
import { EButtonVariants } from 'constants/Buttons';
import { emptyFieldHolder } from 'components/molecules/CardList';
import { useTranslations } from 'hooks/useTranslations';
import { EPermission } from 'models/permissions';

interface IAccessoriesCard {
  data: ITableDataSource;
  handleView?: (args: string) => void;
  handleEdit?: (args: string) => void;
  handleSelect?: () => void;
  isTransactionPage: boolean;
}

const AncillariesReferenceComponentsCard = ({
  data,
  handleView,
  handleEdit,
  handleSelect,
  isTransactionPage,
}: IAccessoriesCard) => {
  const { t } = useTranslations();

  return (
    <Grid
      container
      sx={{
        border: colors.gray200,
        borderRadius: '4px',
        overflow: 'hidden',
        mt: 1,
        backgroundColor: colors.gray100,
      }}
    >
      <Grid sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('ancillariesReferenceTable.accordion.ancillary.column')}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.ancillary)}</Typography>
      </Grid>
      <Grid sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('ancillariesReferenceTable.accordion.artId.column')}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.artId)}</Typography>
      </Grid>
      <Grid sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('ancillariesReferenceTable.accordion.componentType.column')}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.componentType)}</Typography>
      </Grid>
      <Grid sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('ancillariesReferenceTable.accordion.accessoryManufacturer.column')}
        </Typography>
        <Typography variant="body2">
          {emptyFieldHolder(data.frtManufacturerUniqueId)}
        </Typography>
      </Grid>
      <Grid sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('ancillariesReferenceTable.accordion.productName.column')}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.productName)}</Typography>
      </Grid>
      <Grid sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('ancillariesReferenceTable.accordion.make.column')}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.frtMakeUniqueId)}</Typography>
      </Grid>
      <Grid sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('ancillariesReferenceTable.accordion.model.column')}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.frtModelUniqueId)}</Typography>
      </Grid>

      <Grid
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderTop: {
            xs: `1px solid ${colors.primary100}`,
            lg: 'none',
          },
          p: 2,
        }}
      >
        <Grid size={{ xs: 12, sm: 3 }} sx={{ mb: { xs: 2, sm: 0 } }}>
          <Typography variant="button" sx={{ textTransform: 'uppercase' }}>
            {t('general.actions.button')}:{' '}
          </Typography>
        </Grid>

        <Grid container spacing={1} sx={{ justifyContent: 'flex-end' }}>
          {handleEdit && !isTransactionPage && (
            <Grid size={{ xs: 12, sm: 6 }}>
              <Button
                label={t('general.edit.button')}
                variant={EButtonVariants.outlined}
                permission={[EPermission.MANAGE_LOCAL_ART]}
                onClick={() => handleEdit(data.id as string)}
                size="small"
                fullWidth
              />
            </Grid>
          )}
          {handleSelect && isTransactionPage && (
            <Grid size={{ xs: 12, sm: 6 }}>
              <Button
                label={t('general.select.text')}
                variant={EButtonVariants.contained}
                onClick={handleSelect}
                size="small"
                fullWidth
              />
            </Grid>
          )}
          {handleView && (
            <Grid size={{ xs: 12, sm: 6 }}>
              <Button
                label="Details"
                variant={EButtonVariants.outlined}
                onClick={() => handleView(data.id as string)}
                size="small"
                fullWidth
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export { AncillariesReferenceComponentsCard };
